import { TagFilled } from '@ant-design/icons'
import { Button } from 'hljd'
import { inject, observer } from 'mobx-react'
import React from 'react'
import Image from '../../components/Image'
import style from './style.module.less'

const NoSet = ({ imgs = [], contentStore }) => {
  return (
    <>
      {!!imgs.length && (
        <div className={style.noSet}>
          <div className={style.tip}>- 以下图片暂未分区 -</div>
          <div className={style.btn}>
            <Button
              onClick={() => contentStore.setSiteVisible(true)}
              type="primary"
              ghost
              size="small"
            >
              批量设置图片区域
            </Button>
          </div>
          {imgs.map(item => (
            <div className={style.img}>
              <Image
                tagText={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TagFilled style={{ marginRight: 4, fontSize: 10 }} />缺少图片区域
                  </div>
                }
                src={item.url}
              />
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default inject('contentStore')(observer(NoSet))
